__turbopack_context__.v({
  "header": "SearchNoResultsState-module__MJ_vFW__header" + " " + __turbopack_context__.i(463539)["header"],
  "list": "SearchNoResultsState-module__MJ_vFW__list" + " " + __turbopack_context__.i(524956)["list"],
  "noResults": "SearchNoResultsState-module__MJ_vFW__noResults",
  "noResultsMessage": "SearchNoResultsState-module__MJ_vFW__noResultsMessage",
  "section": "SearchNoResultsState-module__MJ_vFW__section" + " " + __turbopack_context__.i(463539)["section"],
  "title": "SearchNoResultsState-module__MJ_vFW__title" + " " + __turbopack_context__.i(463539)["title"],
});
